/**
 * Action types for client functionality functionality.
 *
 * These constants are typically used in Redux action creators and reducers to handle user authentication.
 */

export const GET_CLIENT = 'GET_CLIENT';
export const GET_CLIENT_SUCCESS = 'GET_CLIENT_SUCCESS';
export const GET_CLIENT_FAIL = 'GET_CLIENT_FAIL';
export const SET_CLIENT_DASHBOARD = 'SET_CLIENT_DASHBOARD';
export const SEARCH_CLIENT = 'SEARCH_CLIENT';
export const SEARCH_CLIENT_SUCCESS = 'SEARCH_CLIENT_SUCCESS';
export const SEARCH_CLIENT_FAIL = 'SEARCH_CLIENT_FAIL';
export const GET_TOPOLOGY_CLIENTS = 'GET_TOPOLOGY_CLIENTS';
export const GET_TOPOLOGY_CLIENTS_SUCCESS = 'GET_TOPOLOGY_CLIENTS_SUCCESS';
export const GET_TOPOLOGY_CLIENTS_FAIL = 'GET_TOPOLOGY_CLIENTS_FAIL';

// kick off client
export const KICKOFF_CLIENT_API_REQUEST = 'KICKOFF_CLIENT_API_REQUEST';
export const KICKOFF_CLIENT_API_SUCCESS = 'KICKOFF_CLIENT_API_SUCCESS';
export const KICKOFF_CLIENT_API_FAIL = 'KICKOFF_CLIENT_API_FAIL';

export const CLIENT_DASH_DOWNLOAD = "CLIENT_DASH_DOWNLOAD";
export const CLIENT_DASH_DOWNLOAD_SUCCESS = "CLIENT_DASH_DOWNLOAD_SUCCESS";

export const GET_CLIENT_MODALS = 'GET_CLIENT_MODALS';
export const GET_CLIENT_MODALS_SUCCESS = 'GET_CLIENT_MODALS_SUCCESS';
export const GET_CLIENT_MODALS_FAIL = 'GET_CLIENT_MODALS_FAIL';

// default password for root user:
export const DEFAULT_AP_CLI_USER_PASSWORD = "hfcl!@ion"